import React,{useState, useContext} from "react";
import './Internetsection.css'
import Title from "../../ui/title/Title";
import List from "../../ui/list-item/List";
import FiberImg from './assets/fiber.svg';
import CameraImg from './assets/camera.svg';
import IpImg from './assets/ip.svg';
import CardPhoto from './assets/card-5.png';
import TitleIcon from './assets/internet-icon.svg';
import Card from "../../ui/card/Card";
import { FormContext } from "../../app/App";

const tarifData = [
    {class: 'tarif', title: "20", desClass: 'tarif-description', classList: 'list-item-tarif', dataName: '20 Мбит', choose: 0},
    {class: 'tarif', title: "50", desClass: 'tarif-description', classList: 'list-item-tarif', dataName: '50 Мбит', choose: 1},
    {class: 'tarif', title: "100", desClass: 'tarif-description', classList: 'list-item-tarif', dataName: '100 Мбит', choose: 2},
    {class: 'tarif', title: "1000", desClass: 'tarif-description', classList: 'list-item-tarif', dataName: '1000 Мбит', choose: 3},
]

const benefitsData = [
    {class: 'image-item', wraper: 'benefit-wraper', img: FiberImg, imageClass: 'fiber', title: 'Высокоскоростная оптоволоконная сеть', titleClass: 'image-title'},
    {class: 'image-item', wraper: 'benefit-wraper', img: IpImg, imageClass: 'ip', title: 'Внешний IP в комплекте', titleClass: 'image-title'},
    {class: 'image-item', wraper: 'benefit-wraper', img: CameraImg, imageClass: 'camera', title: 'Доступ в единую систему видеокамер', titleClass: 'image-title'},
]

const cardData = {img: CardPhoto, tarif: '10Гб', measuring: 'до', titleIcon: TitleIcon, classTitle: 'internet-first', title: 'Безлимитный интернет', benefits: ['Бесплатное подключение*', 
                                                                                                                    'Персональное ценовое предложение',
                                                                                                                    'Выделеный менеджер',
                                                                                                                    'Техническая поддержка 24/7',
                                                                                                                    'Личный кабинет']}



export default function Internet()
{
    const [activeIndex, setActiveIndex] = useState(2);
    const { os } = useContext(FormContext);
    return (
        <section id="internet"  className="main-internet"> 
            <p className={`background-line-internet ${os == 'android' ? 'android-inet' : ''}`}>интернет</p>
            <div className="container">
                <Title props={ {type: "section-title", title: "Интернет"}  }  />
                <ul className="tarif-list">
                    {tarifData.map(tarif => {
                        return ( <List props={ tarif } isChoose={activeIndex === tarif.choose} onChoose={() => setActiveIndex(tarif.choose)}/>)
                    })}
                </ul>
                <Card props={ cardData }/>
                <ul  className="benefits">
                    {benefitsData.map(benefit => {
                        return ( <List props={ benefit }/>)
                    })}
                </ul>
            </div>
        </section>
    )
}